<script>
    import { createEventDispatcher } from 'svelte';

    import NextDue from 'src/fields/NextDue/NextDue.svelte';

    const dispatch = createEventDispatcher();
</script>

<NextDue
    {...$$props}

    dateFieldName="next_due_date"
    hoursFieldName="next_due_hours"
    landingsFieldName="next_due_landings"
    cyclesFieldName="next_due_cycles"

    on:change={({ detail: value }) => dispatch('change', value)}
/>
